@file:OptIn(InternalResourceApi::class)

package soundgame.app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/soundgame.app.shared.generated.resources/"

@delegate:ResourceContentHash(-1_112_397_653)
internal val Res.drawable.avatar_00: DrawableResource by lazy {
      DrawableResource("drawable:avatar_00", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_00.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_594_882_045)
internal val Res.drawable.avatar_01: DrawableResource by lazy {
      DrawableResource("drawable:avatar_01", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_01.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_739_642_828)
internal val Res.drawable.avatar_02: DrawableResource by lazy {
      DrawableResource("drawable:avatar_02", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_02.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_061_750_273)
internal val Res.drawable.avatar_03: DrawableResource by lazy {
      DrawableResource("drawable:avatar_03", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_03.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_116_737_319)
internal val Res.drawable.avatar_04: DrawableResource by lazy {
      DrawableResource("drawable:avatar_04", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_04.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-24_917_329)
internal val Res.drawable.avatar_05: DrawableResource by lazy {
      DrawableResource("drawable:avatar_05", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_05.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-902_663_130)
internal val Res.drawable.avatar_06: DrawableResource by lazy {
      DrawableResource("drawable:avatar_06", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_06.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_574_051_288)
internal val Res.drawable.avatar_07: DrawableResource by lazy {
      DrawableResource("drawable:avatar_07", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_07.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-117_031_549)
internal val Res.drawable.avatar_08: DrawableResource by lazy {
      DrawableResource("drawable:avatar_08", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_08.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_652_608_869)
internal val Res.drawable.avatar_09: DrawableResource by lazy {
      DrawableResource("drawable:avatar_09", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_09.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_470_111_204)
internal val Res.drawable.avatar_10: DrawableResource by lazy {
      DrawableResource("drawable:avatar_10", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_10.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(127_498_919)
internal val Res.drawable.avatar_11: DrawableResource by lazy {
      DrawableResource("drawable:avatar_11", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_11.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_591_030_264)
internal val Res.drawable.avatar_12: DrawableResource by lazy {
      DrawableResource("drawable:avatar_12", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_12.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_643_460_728)
internal val Res.drawable.avatar_13: DrawableResource by lazy {
      DrawableResource("drawable:avatar_13", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_13.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(18_712_752)
internal val Res.drawable.avatar_14: DrawableResource by lazy {
      DrawableResource("drawable:avatar_14", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_14.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(836_857_026)
internal val Res.drawable.avatar_15: DrawableResource by lazy {
      DrawableResource("drawable:avatar_15", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_15.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_172_150_302)
internal val Res.drawable.avatar_16: DrawableResource by lazy {
      DrawableResource("drawable:avatar_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_16.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_081_325_551)
internal val Res.drawable.avatar_17: DrawableResource by lazy {
      DrawableResource("drawable:avatar_17", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_17.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_523_199_326)
internal val Res.drawable.avatar_18: DrawableResource by lazy {
      DrawableResource("drawable:avatar_18", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_18.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(905_669_039)
internal val Res.drawable.avatar_19: DrawableResource by lazy {
      DrawableResource("drawable:avatar_19", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_19.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-170_911_362)
internal val Res.drawable.avatar_20: DrawableResource by lazy {
      DrawableResource("drawable:avatar_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_20.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_613_978_236)
internal val Res.drawable.avatar_21: DrawableResource by lazy {
      DrawableResource("drawable:avatar_21", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_21.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(15_628_180)
internal val Res.drawable.avatar_22: DrawableResource by lazy {
      DrawableResource("drawable:avatar_22", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_22.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_953_786_835)
internal val Res.drawable.avatar_23: DrawableResource by lazy {
      DrawableResource("drawable:avatar_23", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_23.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_189_641_183)
internal val Res.drawable.avatar_24: DrawableResource by lazy {
      DrawableResource("drawable:avatar_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_24.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(69_974_830)
internal val Res.drawable.bg_record: DrawableResource by lazy {
      DrawableResource("drawable:bg_record", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_record.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-961_556_417)
internal val Res.drawable.bg_salad: DrawableResource by lazy {
      DrawableResource("drawable:bg_salad", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_salad.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-565_277_659)
internal val Res.drawable.logo_header: DrawableResource by lazy {
      DrawableResource("drawable:logo_header", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_header.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_747_488_248)
internal val Res.drawable.placeholder_qr: DrawableResource by lazy {
      DrawableResource("drawable:placeholder_qr", setOf(
        ResourceItem(setOf(), "${MD}drawable/placeholder_qr.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-508_540_020)
internal val Res.drawable.winner_badge: DrawableResource by lazy {
      DrawableResource("drawable:winner_badge", setOf(
        ResourceItem(setOf(), "${MD}drawable/winner-badge.svg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("avatar_00", Res.drawable.avatar_00)
  map.put("avatar_01", Res.drawable.avatar_01)
  map.put("avatar_02", Res.drawable.avatar_02)
  map.put("avatar_03", Res.drawable.avatar_03)
  map.put("avatar_04", Res.drawable.avatar_04)
  map.put("avatar_05", Res.drawable.avatar_05)
  map.put("avatar_06", Res.drawable.avatar_06)
  map.put("avatar_07", Res.drawable.avatar_07)
  map.put("avatar_08", Res.drawable.avatar_08)
  map.put("avatar_09", Res.drawable.avatar_09)
  map.put("avatar_10", Res.drawable.avatar_10)
  map.put("avatar_11", Res.drawable.avatar_11)
  map.put("avatar_12", Res.drawable.avatar_12)
  map.put("avatar_13", Res.drawable.avatar_13)
  map.put("avatar_14", Res.drawable.avatar_14)
  map.put("avatar_15", Res.drawable.avatar_15)
  map.put("avatar_16", Res.drawable.avatar_16)
  map.put("avatar_17", Res.drawable.avatar_17)
  map.put("avatar_18", Res.drawable.avatar_18)
  map.put("avatar_19", Res.drawable.avatar_19)
  map.put("avatar_20", Res.drawable.avatar_20)
  map.put("avatar_21", Res.drawable.avatar_21)
  map.put("avatar_22", Res.drawable.avatar_22)
  map.put("avatar_23", Res.drawable.avatar_23)
  map.put("avatar_24", Res.drawable.avatar_24)
  map.put("bg_record", Res.drawable.bg_record)
  map.put("bg_salad", Res.drawable.bg_salad)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("logo_header", Res.drawable.logo_header)
  map.put("placeholder_qr", Res.drawable.placeholder_qr)
  map.put("winner_badge", Res.drawable.winner_badge)
}
